import React from 'react';

import { Contact } from 'components/Contact/Contact';
import { Help } from 'components/Help/Help';
import { LanguageSelector } from 'components/LanguageSelector/LanguageSelector';
import { IsEmbedded } from 'containers/IsEmbedded/IsEmbedded';
import { Theme } from 'containers/Theme/Theme';

import './PreFooter.scss';

const PreFooter = () => (
  <Theme
    render={({ preFooter }) => (
      <>
        {preFooter ? (
          <IsEmbedded>
            <section className="PreFooter">
              <Contact />
              <Help />
              <LanguageSelector upward />
            </section>
          </IsEmbedded>
        ) : null}
      </>
    )}
  />
);

export { PreFooter };
